export function registerImageLightbox(containerSelector = '.image-slideshow-component', linkSelector = '.image-lightbox') {
	const overlay = document.getElementById('lightboxOverlay');

	if (!overlay) return;

	const overlayImg = document.getElementById('lightboxImg');
	const overlayTitle = document.getElementById('lightboxTitle');
	const overlayClose = overlay.querySelector('.lightbox-close');
	const prevBtn = overlay.querySelector('.lightbox-prev');
	const nextBtn = overlay.querySelector('.lightbox-next');

	let currentLinks = [];
	let currentIndex = 0;

	function showAtIndex(idx) {
		if (idx < 0 || idx >= currentLinks.length) return;

		const link = currentLinks[idx];
		const img = link.querySelector('img');

		overlayImg.src = link.getAttribute('href');
		overlayImg.alt = img?.alt || '';
		overlayTitle.textContent = link.getAttribute('data-title') || '';
		overlay.style.display = 'flex';
		currentIndex = idx;

		prevBtn.style.display = currentIndex === 0 ? 'none' : '';
		nextBtn.style.display = currentIndex === currentLinks.length - 1 ? 'none' : '';
	}

	// Per component
	const containers = document.querySelectorAll(containerSelector);
	containers.forEach(container => {
		const links = Array.from(container.querySelectorAll(linkSelector));
		links.forEach((link, idx) => {
			link.addEventListener('click', function (e) {
				e.preventDefault();
				currentLinks = links; 
				showAtIndex(idx);
				overlayClose.focus();

				if (typeof window.bananas === 'function') {
					const img = link.querySelector('img');
					window.bananas('event', 'image-lightbox-open', {
						src: link.getAttribute('href'),
						alt: img?.alt || '',
						title: link.getAttribute('data-title') || '',
						page: window.location.pathname,
					});
				}
			});
		});
	});

	// Prev/next buttons
	prevBtn.addEventListener('click', e => {
		e.stopPropagation();
		if (currentIndex > 0) showAtIndex(currentIndex - 1);
	});
	nextBtn.addEventListener('click', e => {
		e.stopPropagation();
		if (currentIndex < currentLinks.length - 1) showAtIndex(currentIndex + 1);
	});

	// Keyboard events
	document.addEventListener('keydown', e => {
		if (overlay.style.display === 'flex') {
			if (e.key === 'Escape') overlayClose.click();
			if (e.key === 'ArrowLeft' && currentIndex > 0) showAtIndex(currentIndex - 1);
			if (e.key === 'ArrowRight' && currentIndex < currentLinks.length - 1) showAtIndex(currentIndex + 1);
		}
	});

	// Close overlay
	overlayClose.addEventListener('click', () => {
		overlay.style.display = 'none';
		overlayImg.src = '';
		overlayTitle.textContent = '';

		if (typeof window.bananas === 'function') {
			window.bananas('event', 'image-lightbox-close', {
				page: window.location.pathname,
			});
		}
	});

	// Click outside image
	overlay.addEventListener('click', e => {
		if (e.target === overlay) overlayClose.click();
	});
}
